import React from 'react';
import type { FC } from 'react';

import Icon from 'components/basic/Icon';
import { IconTypes } from 'components/basic/Icon/types';
import ApplicationForm from 'components/complex/forms/ApplicationForm';

import s from './ApplicationPage.module.scss';

const ApplicationPage: FC = () => {
  return (
    <ApplicationForm
      logo={
        <div className={s.wrapper}>
          <Icon icon={IconTypes.logo} className={s.mainLogo} />
          <span className={s.cross}>×</span>
          <img
            src="/componentsImages/ApplicationPage/lan-billing-logo.svg"
            className={s.lanBillingLogo}
            alt=""
          />
        </div>
      }
    />
  );
};

export default ApplicationPage;
